import { ReactComponent as Bus } from "@/assets/icons/bus.svg";
import { ReactComponent as Minibus } from "@/assets/icons/minibus.svg";
import { ReactComponent as Minivan } from "@/assets/icons/minivan.svg";
import { ReactComponent as Sedan } from "@/assets/icons/sedan.svg";
import { ReactComponent as Sport } from "@/assets/icons/sport.svg";
import { ReactComponent as Suv } from "@/assets/icons/suv.svg";

type IllustrationComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

const map: Record<string, IllustrationComponent> = {
  "economy-sedan": Sedan,
  "executive-sedan": Sedan,
  "premium-sedan": Sedan,
  "sports-car": Sport,
  "suv-economy": Suv,
  "suv-executive": Suv,
  "7-seater-people-mover": Minivan,
  "11-seater-people-mover": Minibus,
  bus: Bus,
};

export const getCategoryIllustration = (cat: { uuid: string; name: string }): IllustrationComponent => {
  const slug = cat.uuid.replace(/^vca-/, "");
  return map[slug] ?? Sedan;
};
